<template>
  <div>
    <!-- Header -->
    <div class="row align-items-center">
      <div class="border-0 mb-4">
        <div class="card-header py-3 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between border-bottom flex-wrap">
          <h3 class="fw-bold mb-0">SMS dəyiş</h3>
        </div>
      </div>
    </div>

    <!-- Body -->
    <div class="card-body">
      <form @submit.prevent="addMessageTemplate">
        <div class="row">
        <div class="col-md-6">
            <label class="form-label">Qrup seç
            </label>
            <select class="form-select" v-model.number="nmsgtemplate.smsGroupId" name="SmsGroups">
              <option></option>
              <option v-for="(partner, index) in smsGroups" :key="index" :value="partner.id">{{ partner.name }}</option>
            </select>
            <span class="inputError">{{ errors.first('smsGroups') }}</span>
        </div>

        <div class="col-md-6">
            <label class="form-label">SMS şablon 
            </label>
            <select class="form-select" v-model.number="smsShablon" name="smsShablons" @change="shablonChanged">
              <option></option>
              <option v-for="(item, index) in smsShablons" :key="index" :value="item">{{ item.name }}</option>
            </select>
            <span class="inputError">{{ errors.first('smsShablons') }}</span>
        </div>

        <div class="col-md-6">
          <label for="date" class="form-label">Göndərmə tarixi
          </label>
          <input type="datetime-local" v-model="nmsgtemplate.sendDate" name="dateField" id="date" class="form-control" required="">
          <span class="inputError">{{ errors.first('dateField') }}</span>
        </div>

        <div class="col-md-6">
            <label class="form-label">Sender</label>
            <select class="form-select" v-model="nmsgtemplate.shortNumber" name="shortCode">
              <option></option>
              <option v-for="(item, index) in shortCodes" :key="index" :value="item">{{ item }}</option>
            </select>
            <span class="inputError">{{ errors.first('shortCode') }}</span>
        </div>
        
        <!-- Template text -->
        <div class="w-100 templateText">
          <label for="templateText" class="form-label">Telefon nömrələri</label>
          <br/>
          <textarea class="w-100 h-100 form-control" v-model="nmsgtemplate.phoneNumbers" name="templateText" id="templateText"></textarea>
        </div>

        <div class="w-100 templateText">
          <label for="smsText" class="form-label">Mətn</label>
          <br/>
          <textarea class="w-100 h-100 form-control" v-model="nmsgtemplate.smsText" v-validate="{ required: true }" name="smsText" id="smsText" :readonly="nmsgtemplate.smsShablonId || user.requiredSmsShablonConfirmation"></textarea>
          <span class="inputError">{{ errors.first('smsText') }}</span>
          <p class="text-end fs-5"><span>Max simvol:</span><span>480</span> &nbsp; | &nbsp;<span>SMS say:</span><b>{{ smsSay }}</b> &nbsp; | &nbsp;<span>SMS uzunluq:</span><b>{{ smsUzunluq }}</b></p>
        </div>

      </div>
        <button type="submit" class="btn btn-primary mt-4" :disabled="loading">
          Göndər
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import jwtInterceptor from '../../../jwt.interceptor'
import user from '../../../store/user'
export default {
  name: 'AddMessageTemplates',
  data() {
    return {
      loading: false,
      user: {},
      nmsgtemplate: {
        smsGroupId: null,
        smsShablonId: null,
        sendDate: "",
        shortNumber: "",
        phoneNumbers: "",
        smsText: ""
      },
      partner:{},
      smsShablon: {},
      partners: [],
      smsGroups: [],
      smsShablons: [],
      shortCodes: []
    }
  },
  methods: {
    shablonChanged(){
      this.nmsgtemplate.smsShablonId = this.smsShablon.id;
      this.nmsgtemplate.smsText = this.smsShablon.content
    },
    async addMessageTemplate() {
      
      const validForm = await this.isFormValid()
      if (validForm) {
        this.loading = true
        jwtInterceptor.put(this.$store.getters.getUrl + "/BulkSms/"+this.nmsgtemplate.id, this.nmsgtemplate).then(response => {
          if (response.data.isError === null) {
            this.$toast.success("Bulk SMS uğurla deyisdirildi!", {
              position: "top-right"
            })
            this.loading = false
            this.$router.go(-1);
          }
          else {
            this.$toast.error("Bir xəta baş verdi. Bir daha sınayın!", {
              position: "top-right"
            });
            this.loading = false
          }
        }).catch((response) => {
          let errorText = ''
          // if (response.response.data.error === 'message_template_of_this_type_for_this_clinic_already_exists')
          //   errorText = 'Bu klinika üçün bu tip şablon artıq vardır!'
          // else
            errorText = 'Bir xəta baş verdi.'
          
          this.$toast.error(errorText, {
            position: "top-right"
          });
          this.loading = false
        })
      } 
      else {
        this.$toast.error("Xanalar düzgün doldurulmayıb. Bir daha xanaları yoxlayın!", {
          position: "top-right"
        })
        this.loading = false
      }
      this.loading = false
    },
    getPartners() {
      var url = '/Users'
      if(this.user.role === 'Partner')
        url += '/GetCurrentUser';
      jwtInterceptor.get(this.$store.getters.getUrl+url)
      .then( response => {
        if(this.user.role === 'Admin')
          this.partners = response.data.result.items;
        else{
          this.partners = response.data.result;
          this.shortCodes = response.data.result.shortNumbers
          this.getsmsGroups();
          this.getsmsShablons();
          this.getShortNumbers();
        }
      })
    },
    getsmsGroups() {
      var url = '/SmsGroups';
      if(this.user.role === 'Partner'){
        url+= "/GetAllByUserId/" + this.user.id + "?userId=" + this.user.id;
      }
      else{
        url+= "/GetAllByUserId/" + this.nmsgtemplate.userId + "?userId=" + this.nmsgtemplate.userId;
      }
      jwtInterceptor.get(this.$store.getters.getUrl+url)
      .then( response => {
        this.smsGroups = response.data.result;
      })
    },
    getsmsShablons() {
      var url = '/SmShablons';
      if(this.user.role === 'Partner'){
        url+= "/GetAllByUserId/" + this.user.id + "?userId=" + this.user.id;
      }
      else{
        url+= "/GetAllByUserId/" + this.nmsgtemplate.userId + "?userId=" + this.nmsgtemplate.userId;
      }
      url += "&onlyApproved=true"
      jwtInterceptor.get(this.$store.getters.getUrl+url)
      .then( response => {
        this.smsShablons = response.data.result;
      })
    },
    getShortNumbers() {
      var url = '/Users';
      if(this.user.role === 'Partner'){
        url+= "/GetUserUniqueShortNumbers/" + this.user.id + "?userId=" + this.user.id;
      }
      else{
        url+= "/GetUserUniqueShortNumbers/" + this.nmsgtemplate.userId + "?userId=" + this.nmsgtemplate.userId;
      }
      jwtInterceptor.get(this.$store.getters.getUrl+url)
      .then( response => {
        this.shortCodes = response.data.result;
      })
    },
    isFormValid() {
      // eslint-disable-next-line vue/no-async-in-computed-properties, no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const valid = await this.$validator.validate();
          resolve(valid);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  created() {
    this.user = user.getters.getUser
    this.nmsgtemplate = user.getters.getTemplateUpdate
    this.nmsgtemplate.phoneNumbers = this.nmsgtemplate.phones.join('\n')
    this.getsmsGroups();
    this.getsmsShablons();
    this.getShortNumbers();
  },
  computed: {
    smsSay(){
      return Math.ceil(this.nmsgtemplate.smsText.length/160);
    },
    smsUzunluq(){
      return this.nmsgtemplate.smsText.length;
    }
  }
}
</script>

<style>
.templateText {
  height: 150px;
  margin-bottom: 2rem;
}

.justify-content-custom {
  justify-content: space-between;
}

@media screen and (max-width: 615px) {
  .justify-content-custom {
    justify-content: space-around !important;
  }
}
</style>